import dayjs from 'dayjs';
import React from 'react';
import { GovernmentMember } from '@benzinga/gov-trades';
import { AiOutlineUnlock } from 'react-icons/ai';

export interface GovTradeOptionI {
  key: string;
  members: GovernmentMember[];
  name: string;
  order: string;
}

export const options: GovTradeOptionI[] = [
  {
    key: 'date_of_last_recorded_trade',
    members: [],
    name: 'Last Traded: New to Old',
    order: 'desc',
  },
  {
    key: 'date_of_last_recorded_trade',
    members: [],
    name: 'Last Traded: Old to New',
    order: 'asc',
  },
  {
    key: 'total_volume_of_trades',
    members: [],
    name: 'Volume: High to Low',
    order: 'desc',
  },
  {
    key: 'total_volume_of_trades',
    members: [],
    name: 'Volume: Low to High',
    order: 'asc',
  },
  {
    key: 'number_of_trades',
    members: [],
    name: 'Total Trades: High to Low',
    order: 'desc',
  },
  {
    key: 'number_of_trades',
    members: [],
    name: 'Total Trades: Low to High',
    order: 'asc',
  },
];

const sortMembers = (key, order) => {
  return (a, b) => {
    let valA = a.stats[key];
    let valB = b.stats[key];

    if (key === 'date_of_last_recorded_trade') {
      valA = dayjs(valA).valueOf();
      valB = dayjs(valB).valueOf();
    }

    if (order === 'asc') {
      return valA - valB;
    } else {
      return valB - valA;
    }
  };
};

export const processSortingMembers = (data): GovTradeOptionI[] => {
  if (!data || data.length === 0) return options;

  const sortedMembers = options.map(option => {
    const members = [...data].sort(sortMembers(option.key, option.order));
    option.members = members;
    return option;
  });
  return sortedMembers;
};

export const SortCongressMembers = ({ locked, membersData, updateMembersList }) => {
  return (
    <div className="rounded-md bg-[#f2f8ff] p-2 text-sm text-bzblue-900 w-fit h-[40px] flex items-center relative group">
      <label className="text-sm">Sort By:</label>
      <select
        className="bg-[#f2f8ff] outline-none"
        disabled={locked}
        onChange={e => {
          const sortKey = e.target.value.split('+')[0];
          const sortOrder = e.target.value.split('+')[1];
          const option = membersData.find(option => option.key === sortKey && option.order === sortOrder);
          updateMembersList(option.members);
        }}
      >
        {membersData &&
          membersData?.map((option, index) => (
            <option key={index} value={`${option.key}+${option.order}`}>
              {option.name}
            </option>
          ))}
      </select>
      {locked && (
        <a
          className="absolute hidden group-hover:flex text-base font-bold text-bzblue-700 w-full backdrop-blur-sm items-center cursor-pointer"
          href="https://www.benzinga.com/premium/ideas/benzinga-edge-checkout/?t=be8be9we4gewe1be11&utm_source=government-trades"
          target="_blank"
        >
          <AiOutlineUnlock size={16} /> Unlock with Benzinga Edge
        </a>
      )}
    </div>
  );
};
